import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Container from "@mui/material/Container";

const useStyles = makeStyles({});

export default ({ data }) => {
  const classes = useStyles();

  return (
    <Container>
      <h1>{data.title}</h1>
    </Container>
  );
};
